var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5668_14084)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6DC0DB",
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.02 8.844H14.98a2.24 2.24 0 0 0-2.231 2.231v17.848a2.24 2.24 0 0 0 2.231 2.232h10.04a2.24 2.24 0 0 0 2.231-2.232V11.075a2.24 2.24 0 0 0-2.23-2.231zm-4.462 20.08h-1.116a1.12 1.12 0 0 1-1.116-1.116c0-.558.558-1.116 1.116-1.116h1.116c.67 0 1.115.558 1.115 1.116 0 .67-.446 1.115-1.115 1.115m4.461-4.462H14.98V11.075h10.04v13.386"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5668_14084"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgMobile;